// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound"}[chunkId] + "." + {"72":"ac6dfe60","187":"f3bc4272"}[chunkId] + ".chunk.js";
};